export const formatJMD = (n) =>
  `J$${Number(n || 0).toLocaleString("en-JM", { maximumFractionDigits: 0 })}`;

export const STATUS_META = {
  pending: { label: "Pending", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  confirmed: { label: "Confirmed", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  out_for_delivery: { label: "Out for Delivery", cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  delivered: { label: "Delivered", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  cancelled: { label: "Cancelled", cls: "bg-rose-100 text-rose-700 border-rose-200" },
};

export const STATUS_ORDER = ["pending", "confirmed", "out_for_delivery", "delivered", "cancelled"];

export const PAYMENT_LABEL = { cod: "Cash on Delivery", bank_transfer: "Bank Transfer" };

export const todayStr = () => new Date().toISOString().slice(0, 10);

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-JM", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return s;
  }
};
